module.exports = __webpack_public_path__ + "img/Instagram.f6697773.webp";